import { render, staticRenderFns } from "./EducationQualification.vue?vue&type=template&id=0e71dca2&scoped=true"
import script from "./EducationQualification.vue?vue&type=script&lang=js"
export * from "./EducationQualification.vue?vue&type=script&lang=js"
import style0 from "./EducationQualification.vue?vue&type=style&index=0&id=0e71dca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e71dca2",
  null
  
)

export default component.exports